import { Fragment, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import ExitButton from 'components/button/ExitButton';
import ScreenMenu from 'components/dropdown/ScreenMenu';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import { Button, Col, Flex, Form, Input, Row, Select, Tooltip } from 'antd';
import { Box, Dialog, DialogTitle, DialogContent, useMediaQuery } from '@mui/material';

const SearchMemberModal = ({ formName, initialValue, dataList, showModal, handleClose }) => {
	const [screenSize, setScreenSize] = useState('sm');

	const [form] = Form.useForm();

	const theme = useTheme();
	const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

	const onOk = () => {
		form.submit();
		handleClose();
	};

	return (
		<Fragment>
			<Dialog
				keepMounted
				fullWidth={true}
				open={showModal}
				maxWidth={screenSize}
				aria-labelledby="draggable-dialog-title"
				fullScreen={screenSize === 'full' ? true : false}
				// sx={{ '.MuiPaper-root': { borderRadius: '8px' } }}
			>
				{/* <AntdValuePreview form={form} show={true} /> */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						bgcolor: '#0052CC',
						justifyContent: 'space-between',
						borderBottom: `1px solid ${theme.palette.divider}`,
						height: '48px',
					}}
				>
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						<DialogTitle
							sx={{ color: 'common.white', display: 'flex', alignItems: 'center', fontSize: '16px', fontWeight: '600 !important' }}
						>
							{/* {icon && <img alt="in progress" src={icon} width="18px" height="18px" style={{ marginRight: '8px' }} />} */}
							Search
						</DialogTitle>
					</Box>

					<Box sx={{ mr: 3, display: 'flex', alignItems: 'center', gap: '12px' }}>
						<Box sx={{ borderRadius: '6px', padding: '2px 12px' }}>
							{!matchDownMD && (
								<>
									<ScreenMenu screenSize={screenSize} setScreenSize={setScreenSize} />

									{/* <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
										<Tooltip title="Small Screen">
											<Box
												onClick={() => setScreenSize('sm')}
												sx={{
													// padding: "4px",
													// paddingBottom: "6px",
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													transition: 'all 0.3s',
													borderBottom: `1px solid ${screenSize === 'sm' ? '#fff' : 'transparent'}`,

													'&:hover': {
														transform: 'scale(1.25)',
													},
												}}
											>
												<ScreenIcon width={9} color="#fff" />
											</Box>
										</Tooltip>

										<Tooltip title="Large Screen">
											<Box
												onClick={() => setScreenSize('md')}
												sx={{
													// padding: "4px",
													// paddingBottom: "6px",
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													transition: 'all 0.3s',
													borderBottom: `1px solid ${screenSize === 'lg' ? '#fff' : 'transparent'}`,

													'&:hover': {
														transform: 'scale(1.2)',
													},
												}}
											>
												<ScreenIcon width={12} color="#fff" />
											</Box>
										</Tooltip>

										<Tooltip title="Full Screen">
											<Box
												onClick={() => setScreenSize('full')}
												sx={{
													// padding: "4px",
													// paddingBottom: "6px",
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													transition: 'all 0.3s',
													borderBottom: `1px solid ${screenSize === 'full' ? '#fff' : 'transparent'}`,

													'&:hover': {
														transform: 'scale(1.2)',
													},
												}}
											>
												<ScreenIcon width={15} color="#fff" />
											</Box>
										</Tooltip>
									</Box> */}
								</>
							)}
						</Box>

						<ExitButton handleClose={handleClose} />
					</Box>
				</Box>

				<DialogContent
				// sx={{
				// 	p: 0,
				// }}
				>
					{form && (
						<Form
							form={form}
							layout="vertical"
							autoComplete="off"
							requiredMark={false}
							// onFinish={handleSubmit}
							name={formName}
							// onFieldsChange={onFieldsChange}
							initialValues={{
								nominatedAs: initialValue?.nominatedAs,
								positionValue: initialValue?.positionValue,
								personName: initialValue?.personName,
							}}
						>
							<Row gutter={[16, 0]}>
								<Col xs={24} md={24}>
									<Form.Item
										label="Nominated By"
										name="nominatedAs"
										rules={[
											{
												required: true,
												message: 'Nominated by is required.',
											},
										]}
									>
										<Select
											allowClear
											showSearch
											size="default"
											style={{ width: '100%' }}
											placeholder="Select from the list"
											onChange={() => {
												form.setFieldsValue({ positionValue: null, personName: null });
											}}
											onClear={() => {
												form.setFieldsValue({ positionValue: null, personName: null });
											}}
											options={[
												{
													label: 'Position',
													value: 'positions',
												},
												{
													label: 'Employee',
													value: 'users',
												},
												{
													label: 'Process Role',
													value: 'processRoles',
												},
											]}
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[16, 0]}>
								<Col xs={24} md={24}>
									<Form.Item
										shouldUpdate={(previousValue, currentValue) => previousValue.nominatedAs !== currentValue.nominatedAs}
										noStyle
									>
										{({ getFieldValue, setFieldValue }) => {
											return (
												<Form.Item
													label="Member Identity"
													name="positionValue"
													rules={[
														{
															required: true,
															message: 'Member identity is required.',
														},
													]}
												>
													<Select
														allowClear
														size="default"
														style={{ width: '100%' }}
														placeholder="Select from the list"
														onSelect={(val, option) => setFieldValue('personName', option.userFullName)}
														onClear={() => {
															form.setFieldsValue({ personName: null });
														}}
														options={dataList?.[getFieldValue('nominatedAs')]}
													/>
												</Form.Item>
											);
										}}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[16, 0]}>
								<Col xs={24} md={24}>
									<Form.Item label="Person Name" name="personName">
										<Input size="default" placeholder="Person name" disabled />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[16, 0]} style={{ justifyContent: 'flex-end' }}>
								<Col xs={24} md={4}>
									<Button
										htmlType="button"
										style={{
											background: '#214689',
											color: 'white',
											width: '100%',
										}}
										onClick={() => onOk()}
									>
										Add
									</Button>
								</Col>
							</Row>
						</Form>
					)}
				</DialogContent>
			</Dialog>
		</Fragment>
	);
};
export default SearchMemberModal;
